export const PAYSAFE = "PAYSAFE"
